import {
  actionTypes as asyncTypes,
  isAsyncOperation,
  isAsyncComplete,
} from "async-ops";
import { cloneDeep } from "lodash";
import {
  isMdaeWidgetOptionChangeEvent,
  updateStateAfterWidgetOptionChange,
  assignVersionToList,
} from "../../../../common_components/mdae-framework";
import { GET_PREDICTION_HISTORY_LIST } from "../services/get-prediction-history-list";
import { GET_DENIAL_RESPONSE_LIST } from "../services/get-denial-response-list";
import { GET_SUMMARY_LIST } from "../services/get-summary-list";
import Guid from "devextreme/core/guid";
import { GET_TOP_FIVE_PROVIDER_LIST } from "../services/get-top-five-provider-list";
import { GET_FACILITY_LIST } from "../../../../common_components/add-case-manual/services/get-facility-list";
import { GET_PAYER_TYPE_LIST } from "../services/get-payer-type-list";
import { convertDateFormat } from "../../../../utils/dateUtils";
import { GET_AUDIT_INSIGHTS_DATA } from "../services/get-rule-response-data";
import { EXPORT_DENIALS_PREDICTORY_SUMMARY } from "../services/export-response-account-list";
import { GET_DENIAL_HISTORY_LIST } from "../services/get-denial-history-list";
import { GET_PAYER_PROCEDURE_CODE_LIST } from "../services/get-payer-and-procedure-code-list";

export const SET_RESPONSE_BREAKDOWN_TAB = "SET_RESPONSE_BREAKDOWN_TAB";
export const SET_RESPONSE_TABLE_TAB = "SET_RESPONSE_TABLE_TAB";
export const SET_DENIALS_PREDICTOR_TAB = "SET_DENIALS_PREDICTOR_TAB";
export const SET_RESPONSE_TABLE_DATASOURCE = "SET_RESPONSE_TABLE_DATASOURCE";
export const SET_RESPONSE_BREAKDOWN_AND_TABLE_DATASOURCE =
  "SET_RESPONSE_BREAKDOWN_AND_TABLE_DATASOURCE";
export const SET_TOP_FIVE_DATASOURCE = "SET_TOP_FIVE_DATASOURCE";
export const SET_PREDICTION_HISTORY_LIST_DATAGRID_FILTER =
  "SET_PREDICTION_HISTORY_LIST_DATAGRID_FILTER";
export const SET_LOOKBACK_PERIOD = "SET_LOOKBACK_PERIOD";
export const SET_RESPONSE_TABLE_GRID_CHECKBOXES =
  "SET_RESPONSE_TABLE_GRID_CHECKBOXES";
export const SET_CURRENT_USER_ACTION_MODE = "SET_CURRENT_USER_ACTION_MODE";
export const SET_IS_CHART_POINT_CLICK = "SET_IS_CHART_POINT_CLICK";
export const SET_IS_PREDICTION_HISTORY_LIST_UPDATED =
  "SET_IS_PREDICTION_HISTORY_LIST_UPDATED";
export const SET_RESPONSE_ALERT_DATA = "SET_RESPONSE_ALERT_DATA";
export const TOGGLE_DENIAL_RESPONSE_POPUP = "TOGGLE_DENIAL_RESPONSE_POPUP";
export const SET_DENIAL_RESPONSE_CLAIM_TYPE = "SET_DENIAL_RESPONSE_CLAIM_TYPE";
export const SET_EXTRACT_START_DATE_AND_RESPONSE_LIST =
  "SET_EXTRACT_START_DATE_AND_RESPONSE_LIST";
export const TOGGLE_LINE_LEVEL_DENIAL_PREDICTOR_POPOVER =
  "TOGGLE_LINE_LEVEL_DENIAL_PREDICTOR_POPOVER";
export const TOGGLE_DENIAL_PREDICTOR_ALERT_POPOVER =
  "TOGGLE_DENIAL_PREDICTOR_ALERT_POPOVER";
export const TOGGLE_PREDICTION_HISTORY_ROW_POPOVER =
  "TOGGLE_PREDICTION_HISTORY_ROW_POPOVER";
export const TOGGLE_EXCLUDE_RULE_POPOVER = "TOGGLE_EXCLUDE_RULE_POPOVER";
export const SET_DATATYPE_SELECTED_AND_EXTRACT_START_DATE =
  "SET_DATATYPE_SELECTED_AND_EXTRACT_START_DATE";
export const SET_RULE_GROUP_PIE_SELECTION = "SET_RULE_GROUP_PIE_SELECTION";
export const UPDATE_COMMENT_TEXT = "UPDATE_COMMENT_TEXT";
export const UPDATE_RSPONSE_DATASOURCE = "UPDATE_RSPONSE_DATASOURCE";
export const UPDATE_EXLUDED_RESPONSE = "UPDATE_EXLUDED_RESPONSE";
export const UPDATE_EXCLUDED_RULES_AND_RULE_GROUPS =
  "UPDATE_EXCLUDED_RULES_AND_RULE_GROUPS";
export const UPDATE_PREDICTIO_HISTORY_LIST = "UPDATE_PREDICTIO_HISTORY_LIST";
export const SET_SELECT_LAST_ROW_INDICATOR = "SET_SELECT_LAST_ROW_INDICATOR";
export const UPDATE_SELECTED_PREDICTION_HISTORY_ROW =
  "UPDATE_SELECTED_PREDICTION_HISTORY_ROW";
export const SET_SUMMARY_BREAKDOWN_TAB = "SET_SUMMARY_BREAKDOWN_TAB";
export const UPDATE_SELECTED_SUMMARY_ROW = "UPDATE_SELECTED_SUMMARY_ROW";
export const SET_SUMMARY_PAYER_TYPE_FILTER = "SET_SUMMARY_PAYER_TYPE_FILTER";
export const SET_SUMMARY_FACILITY_FILTER = "SET_SUMMARY_FACILITY_FILTER";
export const SET_SUMMARY_RULE_CLASS_FILTER = "SET_SUMMARY_RULE_CLASS_FILTER";
export const SET_SUMMARY_FROM_DATE_FILTER = "SET_SUMMARY_FROM_DATE_FILTER";
export const SET_SUMMARY_TO_DATE_FILTER = "SET_SUMMARY_TO_DATE_FILTER";
export const SET_SUMMARY_CLEAR_FILTER = "SET_SUMMARY_CLEAR_FILTER";
export const SET_RULE_RESPOSE_DATA = "SET_RULE_RESPOSE_DATA";
export const TOGGLE_DENIALS_HISTORY_RESPONSE_POPUP =
  "TOGGLE_DENIALS_HISTORY_RESPONSE_POPUP";
export const SET_DENIALS_HISTORY_LIST = "SET_DENIALS_HISTORY_LIST";
export const SET_SAMPLES_SIZE_VALUE = "SET_SAMPLES_SIZE_VALUE";
export const SET_DENIALS_ACCOUNT_LIST = "SET_DENIALS_ACCOUNT_LIST";
export const SET_SELECTED_KEYS_DENIALS_HISTORY_LIST =
  "SET_SELECTED_KEYS_DENIALS_HISTORY_LIST";
export const SET_PREDICTION_HISTORY_DATA_TYPE =
  "SET_PREDICTION_HISTORY_DATA_TYPE";
export const SET_ACCORDIAN_LIST_CHECKBOX_DISABLED =
  "SET_ACCORDIAN_LIST_CHECKBOX_DISABLED";
export const SET_ACCOUNT_LIST_CHECKBOX_DISABLED =
  "SET_ACCOUNT_LIST_CHECKBOX_DISABLED";
export const SET_CASE_DETAIL_LIST = "SET_CASE_DETAIL_LIST";
export const SET_CODE_PAYER_LIST = "SET_CODE_PAYER_LIST";
export const SET_DEFAULT_VALUE = "SET_DEFAULT_VALUE";
export const SET_EXPAND_ROW_LIST = "SET_EXPAND_ROW_LIST";
export const SET_COLLAPSE_ROW_LIST = "SET_COLLAPSE_ROW_LIST";
export const SET_CURRENT_SELECTED_ROW = "SET_CURRENT_SELECTED_ROW";
export const SET_SUMMARY_LIST_HEIGHT="SET_SUMMARY_LIST_HEIGHT";
export const SET_IS_SEARCH_TEXT_ADDED = "SET_IS_SEARCH_TEXT_ADDED";

export const RESPONSE_BREAKDOWN_TAB = {
  RULE_GROUP: "Rule Group",
  PAYER_TYPE: "Payer Type",
  TOP_CPT_HCPCS: "Top CPT/HCPCS",
  TOP_FACILITIES: "Top Facilities",
};
export const SUMMARY_BREAKDOWN_TAB = {
  PROVIDERS: "Providers",
  PAYERS: "Payers",
  FACILITIES: "Facilities",
  CODERS: "Coders",
};
export const RESPONSE_TABLE_TAB = {
  UNREVIEWED: "Unreviewed",
  CORRECTED: "Corrected",
  IGNORED: "Ignored",
  ALL: "All",
  ADDTOAUDIT: "Add to Audit",
};
export const DENIALS_PREDICTOR_TAB = {
  DENIALS_PREDICTOR: "Denials Predictor",
  AGGREGATED_VIEW: "Aggregated View",
};
export const responseTableGridSelection = {
  mode: "single",
  showCheckBoxesMode: "always",
  selectAllMode: "allPages",
};
export const lookBackPeriodData = [5, 10, 15];
export const RESPONSE_ACTION = {
  CORRECTED: "corrected",
  IGNORED: "ignored",
};
export const DATASOURCE_TYPE = {
  PROSPECTIVE: "prospective",
  RETROSPECTIVE: "retrospective",
};
export const ruleClassList = [
  { Id: -1, Name: "All" },
  { Id: 0, Name: "Informational" },
  { Id: 1, Name: "Actionable" },
];
export const searchTypeList = [
  { Id: -1, Name: "Rule Keywords" },
  { Id: 0, Name: "CPT/HCPCS Codes" },
  { Id: 1, Name: "Payer Names" }  
];

export const defaultSummaryTabFilters = {
  fromDate: convertDateFormat(
    new Date().setMonth(new Date().getMonth() - 6),
    "MM/DD/YYYY"
  ),
  toDate: convertDateFormat(new Date(), "MM/DD/YYYY"),
  ruleClass: ruleClassList[2].Id,
  facility: [],
  payerType: [],
};
export const DENIAL_PREDICTOR_LOOKBACKPERIOD =
  "Denial_Predictor_LookBackPeriod";
const initialState = {
  predictionHistoryList: [],
  isBothDataTypeSelected: false,
  responseBreakdownTabs: [
    RESPONSE_BREAKDOWN_TAB.RULE_GROUP,
    RESPONSE_BREAKDOWN_TAB.PAYER_TYPE,
    RESPONSE_BREAKDOWN_TAB.TOP_CPT_HCPCS,
    RESPONSE_BREAKDOWN_TAB.TOP_FACILITIES,
  ],
  responseTableTabs: [
    RESPONSE_TABLE_TAB.UNREVIEWED,
    RESPONSE_TABLE_TAB.CORRECTED,
    RESPONSE_TABLE_TAB.IGNORED,
    RESPONSE_TABLE_TAB.ALL,
  ],
  summaryBreakdownTabs: [
    SUMMARY_BREAKDOWN_TAB.PROVIDERS,
    SUMMARY_BREAKDOWN_TAB.PAYERS,
    SUMMARY_BREAKDOWN_TAB.FACILITIES,
    SUMMARY_BREAKDOWN_TAB.CODERS,
  ],
  responseTableRightSectionTabs: [RESPONSE_TABLE_TAB.ADDTOAUDIT],
  tabSelected: RESPONSE_BREAKDOWN_TAB.RULE_GROUP,
  responseTableTabSelected: RESPONSE_TABLE_TAB.UNREVIEWED,
  responseList: [],
  ruleGroupPieChartDataSource: [],
  payerTypePieChartDataSource: [],
  cpthcpcsBarChartDataSource: [],
  facilityBarChartDataSource: [],
  responseTableDataSource: [],
  responseTableAddtoAuditDataSource: [],
  responseTableGridSelection,
  isChartPointClick: false,
  bulkResponseAction: "",
  isPredictionHistoryListUpdated: false,
  excludedResponseList: [],
  excludedRulesAndRuleGroups: [],
  selectLastRowForPredictionListInd: true,
  selectedPredictionHistoryRowKey: 0,
  unReviewedResponseList: [],
  correctedResponseList: [],
  ignoredResponseList: [],
  allResponseList: [],
  denialsPredictorTabs: [
    DENIALS_PREDICTOR_TAB.DENIALS_PREDICTOR,
    DENIALS_PREDICTOR_TAB.AGGREGATED_VIEW,
  ],
  denialsPredictorTabSelected: DENIALS_PREDICTOR_TAB.DENIALS_PREDICTOR,
  summaryList: [],
  topFiveProviderChartDatasource: [],
  topFivePayerTypeChartDataSource: [],
  topFiveFacilityChartDataSource: [],
  topFiveCoderChartDataSource: [],
  summaryTabSelected: SUMMARY_BREAKDOWN_TAB.PROVIDERS,
  selectedSummaryRowKey: 0,
  selectedRowIndex: 0,
  fromDate: defaultSummaryTabFilters.fromDate,
  toDate: defaultSummaryTabFilters.toDate,
  ruleClass: defaultSummaryTabFilters.ruleClass,
  facility: defaultSummaryTabFilters.facility,
  payerType: defaultSummaryTabFilters.payerType,
  facilityList: [],
  payerTypeList: [],
  getRuleResponseData: {},
  getRuleHotspotData: [],
  getDenialHistoryList: [],
  hcpcsCodes: [],
  sampleSize: 10,
  collapseRowList: [],
  payerNameList:[],
  procedureCodeList: [],
  isSeachTextAdded: false,
};

export default function(state = initialState, action) {
  let newState;
  switch (action.type) {
    case asyncTypes.OPERATION:
    case asyncTypes.COMPLETE:
    case asyncTypes.FAILURE:
      if (isAsyncOperation(GET_PREDICTION_HISTORY_LIST)(action)) {
        return {
          ...state,
          predictionHistoryList: [],
          isBothDataTypeSelected: false,
          responseList: [],
        };
      }
      if (isAsyncComplete(GET_PREDICTION_HISTORY_LIST)(action)) {
        const response = action.response;
        const guid = new Guid().toString();
        if (response.responseList.length > 0)
          response.responseList[0].version = guid;
        return {
          ...state,
          predictionHistoryList: response.predictionHistoryList,
          isBothDataTypeSelected: response.isBothDataTypeSelected,
          denialsPredictorConfiguration:
            response.denialsPredictorConfiguration[0],
          responseList: response.responseList,
        };
      }

      if (isAsyncOperation(GET_SUMMARY_LIST)(action)) {
        return {
          ...state,
          summaryList: [],
        };
      }
      if (isAsyncComplete(GET_SUMMARY_LIST)(action)) {
        const response = action.response;
        return {
          ...state,
          summaryList: response.summaryList,
        };
      }      
      if (isAsyncOperation(EXPORT_DENIALS_PREDICTORY_SUMMARY)(action)) {
        return {
          ...state,
          response: [],
        };
      }
      if (isAsyncComplete(EXPORT_DENIALS_PREDICTORY_SUMMARY)(action)) {
        const response = action.result;
        return {
          ...state,
          response: response,
        };
      }
      if (isAsyncOperation(GET_TOP_FIVE_PROVIDER_LIST)(action)) {
        return {
          ...state,
          topFiveProviderChartDatasource: [],
          topFivePayerTypeChartDataSource: [],
          topFiveFacilityChartDataSource: [],
          topFiveCoderChartDataSource: [],
        };
      }
      if (isAsyncComplete(GET_TOP_FIVE_PROVIDER_LIST)(action)) {
        const response = action.response;
        return {
          ...state,
          topFiveProviderChartDatasource:
            response.topFiveProviderChartDatasource,
          topFivePayerTypeChartDataSource:
            response.topFivePayerTypeChartDataSource,
          topFiveFacilityChartDataSource:
            response.topFiveFacilityChartDataSource,
          topFiveCoderChartDataSource: response.topFiveCoderChartDataSource,
        };
      }

      if (isAsyncOperation(GET_DENIAL_RESPONSE_LIST)(action)) {
        return { ...state, responseList: [] };
      }
      if (isAsyncComplete(GET_DENIAL_RESPONSE_LIST)(action)) {
        const response = action.response;
        const guid = new Guid().toString();
        response.responseList[0].version = guid;
        return { ...state, responseList: response.responseList };
      }
      if (isAsyncOperation(GET_FACILITY_LIST)(action)) {
        return {
          ...state,
          facilityList: [],
        };
      }
      if (isAsyncComplete(GET_FACILITY_LIST)(action)) {
        const response = action.response;
        return {
          ...state,
          facilityList: response,
        };
      }
      if (isAsyncOperation(GET_PAYER_TYPE_LIST)(action)) {
        return {
          ...state,
          payerTypeList: [],
        };
      }
      if (isAsyncComplete(GET_PAYER_TYPE_LIST)(action)) {
        const response = action.response;
        return {
          ...state,
          payerTypeList: response,
        };
      }
      if (isAsyncOperation(GET_PAYER_PROCEDURE_CODE_LIST)(action)) {
        return {
          ...state,
          payerNameList: [],
          procedureCodeList: [],
        };
      }
      if (isAsyncComplete(GET_PAYER_PROCEDURE_CODE_LIST)(action)) {
        const response = action.response;        
        return {
          ...state,
          payerNameList: response.payerNameList,
          procedureCodeList: response.procedureCodeList,
        };
      }
      if (isAsyncOperation(GET_AUDIT_INSIGHTS_DATA)(action)) {
        return {
          ...state,
          getRuleResponseData: {},
          getRuleHotspotData: [],
          hcpcsCodes: [],
        };
      }
      if (isAsyncComplete(GET_AUDIT_INSIGHTS_DATA)(action)) {
        const response = action.response;
        return {
          ...state,
          getRuleResponseData: response.getRuleResponseData,
          getRuleHotspotData: response.getRuleHotspotData,
          hcpcsCodes: response.getRuleHotspotData.map((obj) => obj.codeValue),
        };
      }
      if (isAsyncOperation(GET_DENIAL_HISTORY_LIST)(action)) {
        return {
          ...state,
          getDenialHistoryList: [],
        };
      }
      if (isAsyncComplete(GET_DENIAL_HISTORY_LIST)(action)) {
        const response = action.response;
        return {
          ...state,
          getDenialHistoryList: response.getDenialHistoryList,
        };
      }
      return state;

    case SET_RESPONSE_BREAKDOWN_TAB:
      return {
        ...state,
        tabSelected: action.data.tabSelected,
      };
    case SET_SUMMARY_BREAKDOWN_TAB:
      return {
        ...state,
        summaryTabSelected: action.data.summaryTabSelected,
      };
    case SET_RESPONSE_TABLE_TAB:
      newState = cloneDeep(state);
      newState = {
        ...newState,
        responseTableTabSelected: action.data.responseTableTabSelected,
        responseTableDataSource: action.data.responseTableDataSource,
        responseTableAddtoAuditDataSource:
          action.data.responseTableAddtoAuditDataSource,
      };
      return newState;
    case SET_DENIALS_PREDICTOR_TAB:
      newState = cloneDeep(state);
      newState = {
        ...newState,
        denialsPredictorTabSelected: action.data.denialsPredictorTabSelected,
      };
      return newState;
    case SET_RESPONSE_TABLE_DATASOURCE:
      return {
        ...state,
        unReviewedResponseList: action.data.unReviewedResponseList,
        correctedResponseList: action.data.correctedResponseList,
        ignoredResponseList: action.data.ignoredResponseList,
        addtoAuditCaseList: action.data.addtoAuditCaseList,
        allResponseList: action.data.allResponseList,
        responseTableDataSource: action.data.responseTableData,
        filteredResponseList: action.data.filteredResponseList,
        responseTableAddtoAuditDataSource: action.data.responseTableData,
      };
    case SET_RESPONSE_BREAKDOWN_AND_TABLE_DATASOURCE:
      return {
        ...state,
        ruleGroupPieChartDataSource: action.data.ruleGroupPieChartDataSource,
        payerTypePieChartDataSource: action.data.payerTypePieChartDataSource,
        cpthcpcsBarChartDataSource: action.data.cpthcpcsBarChartDataSource,
        facilityBarChartDataSource: action.data.facilityBarChartDataSource,
        unReviewedResponseList: action.data.unReviewedResponseList,
        correctedResponseList: action.data.correctedResponseList,
        ignoredResponseList: action.data.ignoredResponseList,
        addtoAuditCaseList: action.data.addtoAuditCaseList,
        allResponseList: action.data.allResponseList,
        responseTableDataSource: action.data.responseTableData,
        filteredResponseList: action.data.filteredResponseList,
        responseTableAddtoAuditDataSource: action.data.responseTableData,
      };
    case SET_IS_CHART_POINT_CLICK:
      return {
        ...state,
        isChartPointClick: action.data.isChartPointClick,
        chartPropertyClick: action.data.chartPropertyClick,
      };
      case SET_IS_SEARCH_TEXT_ADDED:
      return {
        ...state,
        isSeachTextAdded: action.data.isSeachTextAdded
      };
    case SET_RULE_GROUP_PIE_SELECTION:
    case SET_DENIAL_RESPONSE_CLAIM_TYPE:
    case TOGGLE_DENIAL_RESPONSE_POPUP:
    case SET_RESPONSE_ALERT_DATA:
    case SET_LOOKBACK_PERIOD:
    case SET_PREDICTION_HISTORY_LIST_DATAGRID_FILTER:
    case SET_RESPONSE_TABLE_GRID_CHECKBOXES:
    case SET_EXTRACT_START_DATE_AND_RESPONSE_LIST:
    case SET_IS_PREDICTION_HISTORY_LIST_UPDATED:
    case TOGGLE_LINE_LEVEL_DENIAL_PREDICTOR_POPOVER:
    case TOGGLE_DENIAL_PREDICTOR_ALERT_POPOVER:
    case TOGGLE_PREDICTION_HISTORY_ROW_POPOVER:
    case SET_DATATYPE_SELECTED_AND_EXTRACT_START_DATE:
    case TOGGLE_EXCLUDE_RULE_POPOVER:
    case TOGGLE_DENIALS_HISTORY_RESPONSE_POPUP:
      newState = { ...state };
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = { ...newState, ...action.data };
      }
      return newState;
    case SET_CURRENT_USER_ACTION_MODE:
      return {
        ...state,
        currentUserActionMode: action.currentUserActionMode,
        bulkResponseAction: action.bulkResponseAction,
      };
    case UPDATE_EXLUDED_RESPONSE:
      return {
        ...state,
        excludedResponseList: action.data,
      };
    case UPDATE_EXCLUDED_RULES_AND_RULE_GROUPS:
      return {
        ...state,
        excludedRulesAndRuleGroups: action.data,
      };
    case SET_SELECT_LAST_ROW_INDICATOR:
      return {
        ...state,
        selectLastRowForPredictionListInd:
          action.selectLastRowForPredictionListInd,
      };
    case UPDATE_SELECTED_PREDICTION_HISTORY_ROW:
      return {
        ...state,
        selectedPredictionHistoryRowKey: action.selectedPredictionHistoryRowKey,
      };
    case UPDATE_SELECTED_SUMMARY_ROW:
      return {
        ...state,
        selectedSummaryRowKey: action.selectedSummaryRowKey,
        ruleId: action.ruleId,
        ruleGroup: action.ruleGroup,
        ruleDetail: action.ruleDetail,
        selectedRowIndex: action.selectedRowIndex,
      };
    case UPDATE_RSPONSE_DATASOURCE:
      return {
        ...state,
        responseList: assignVersionToList(action.data),
      };
    case UPDATE_COMMENT_TEXT:
      newState = { ...state };
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        if (state.responseTableTabSelected == "Unreviewed") {
          const index = newState.unReviewedResponseList.findIndex(
            (item) => item.amsFacsResponseId === action.data.amsFacsResponseId
          );
          const updateComment = newState.unReviewedResponseList[index];
          updateComment.comment = action.data.commentText;
          const responseTableDataSource = [
            ...newState.unReviewedResponseList.slice(0, index),
            updateComment,
            ...newState.unReviewedResponseList.slice(index + 1),
          ];
          newState = {
            ...newState,
            responseTableDataSource: assignVersionToList(
              responseTableDataSource
            ),
            unReviewedResponseList: assignVersionToList(
              responseTableDataSource
            ),
          };
        } else if (state.responseTableTabSelected == "Corrected") {
          const index = newState.correctedResponseList.findIndex(
            (item) => item.amsFacsResponseId === action.data.amsFacsResponseId
          );
          const updateComment = newState.correctedResponseList[index];
          updateComment.comment = action.data.commentText;
          const responseTableDataSource = [
            ...newState.correctedResponseList.slice(0, index),
            updateComment,
            ...newState.correctedResponseList.slice(index + 1),
          ];
          newState = {
            ...newState,
            responseTableDataSource: assignVersionToList(
              responseTableDataSource
            ),
            correctedResponseList: assignVersionToList(responseTableDataSource),
          };
        } else if (state.responseTableTabSelected == "Ignored") {
          const index = newState.ignoredResponseList.findIndex(
            (item) => item.amsFacsResponseId === action.data.amsFacsResponseId
          );
          const updateComment = newState.ignoredResponseList[index];
          updateComment.comment = action.data.commentText;
          const responseTableDataSource = [
            ...newState.ignoredResponseList.slice(0, index),
            updateComment,
            ...newState.ignoredResponseList.slice(index + 1),
          ];
          newState = {
            ...newState,
            responseTableDataSource: assignVersionToList(
              responseTableDataSource
            ),
            ignoredResponseList: assignVersionToList(responseTableDataSource),
          };
        } else if (state.responseTableTabSelected == "All") {
          const index = newState.allResponseList.findIndex(
            (item) => item.amsFacsResponseId === action.data.amsFacsResponseId
          );
          const updateComment = newState.allResponseList[index];
          updateComment.comment = action.data.commentText;
          const responseTableDataSource = [
            ...newState.allResponseList.slice(0, index),
            updateComment,
            ...newState.allResponseList.slice(index + 1),
          ];
          newState = {
            ...newState,
            responseTableDataSource: assignVersionToList(
              responseTableDataSource
            ),
            allResponseList: assignVersionToList(responseTableDataSource),
          };
        }
        const index1 = newState.responseList.findIndex(
          (item) => item.amsFacsResponseId === action.data.amsFacsResponseId
        );
        const updateComment1 = newState.responseList[index1];
        updateComment1.comment = action.data.commentText;
        const responseTableDataSource1 = [
          ...newState.responseList.slice(0, index1),
          updateComment1,
          ...newState.responseList.slice(index1 + 1),
        ];

        newState = {
          ...newState,
          responseList: assignVersionToList(responseTableDataSource1),
        };
      }
      return newState;
    case SET_SUMMARY_FACILITY_FILTER:
      return {
        ...state,
        facility: action.data.facility,
      };
    case SET_SUMMARY_PAYER_TYPE_FILTER:
      return {
        ...state,
        payerType: action.data.payerType,
      };
    case SET_SUMMARY_RULE_CLASS_FILTER:
      return {
        ...state,
        ruleClass: action.data.ruleClass,
      };
    case SET_SUMMARY_FROM_DATE_FILTER:
      return {
        ...state,
        fromDate: action.data.fromDate,
      };
    case SET_SUMMARY_TO_DATE_FILTER:
      return {
        ...state,
        toDate: action.data.toDate,
      };
    case SET_SUMMARY_CLEAR_FILTER:
      return {
        ...state,
        facility: action.data.facility,
        payerType: action.data.payerType,
        ruleClass: action.data.ruleClass,
        fromDate: action.data.fromDate,
        toDate: action.data.toDate,
        getRuleResponseData: [],
      };
    case SET_RULE_RESPOSE_DATA:
      return {
        ...state,
        getRuleResponseData: action.data.getRuleResponseData,
      };
    case SET_DENIALS_HISTORY_LIST:
      return {
        ...state,
        getDenialHistoryList: action.data.getDenialHistoryList,
      };
    case SET_SAMPLES_SIZE_VALUE:
      return {
        ...state,
        sampleSize: action.data.sampleSize,
      };
    case SET_DENIALS_ACCOUNT_LIST:
      let itemIndex = state.getDenialHistoryList.findIndex(
        (obj) =>
          obj.hcpcs === action.data.hcpcs &&
          obj.payerName === action.data.payerName &&
          obj.claimTypeCode === action.data.claimTypeCode
      );
      return {
        ...state,
        getDenialHistoryList: [
          ...state.getDenialHistoryList.slice(0, itemIndex),
          {
            ...state.getDenialHistoryList[itemIndex],
            denialResponseAccountList: action.data.denialResponseAccountList,
          },
          ...state.getDenialHistoryList.slice(itemIndex + 1),
        ],
      };
    case SET_SELECTED_KEYS_DENIALS_HISTORY_LIST:
      let selectedKeysIndex = state.getDenialHistoryList.findIndex(
        (obj) =>
          obj.hcpcs === action.data.hcpcs &&
          obj.payerName === action.data.payerName &&
          obj.claimTypeCode === action.data.claimTypeCode
      );
      return {
        ...state,
        getDenialHistoryList: [
          ...state.getDenialHistoryList.slice(0, selectedKeysIndex),
          {
            ...state.getDenialHistoryList[selectedKeysIndex],
            selectedAccountKeys: action.data.selectedAccountKeys,
          },
          ...state.getDenialHistoryList.slice(selectedKeysIndex + 1),
        ],
      };
    case SET_PREDICTION_HISTORY_DATA_TYPE:
      return {
        ...state,
        predictionHistoryDataType: action.data.predictionHistoryDataType,
      };
    case SET_ACCORDIAN_LIST_CHECKBOX_DISABLED:
      return {
        ...state,
        isAccordianListCheckboxDisabled:
          action.data.isAccordianListCheckboxDisabled,
      };
    case SET_ACCOUNT_LIST_CHECKBOX_DISABLED:
      return {
        ...state,
        isAccountListCheckboxDisabled:
          action.data.isAccountListCheckboxDisabled,
      };
    case SET_CASE_DETAIL_LIST:
      return {
        ...state,
        caseDetailList: action.data.caseDetailList,
      };
    case SET_CODE_PAYER_LIST:
      return {
        ...state,
        codePayerList: action.data.codePayerList,
      };
    case SET_DEFAULT_VALUE:
      return {
        ...state,
        codePayerList: action.data.codePayerList,
        caseDetailList: action.data.caseDetailList,
        isAccordianListCheckboxDisabled:
          action.data.isAccordianListCheckboxDisabled,
        isAccountListCheckboxDisabled:
          action.data.isAccountListCheckboxDisabled,
        sampleSize: action.data.sampleSize,
      };
    case SET_EXPAND_ROW_LIST:
      let expandedRow = action.data.expandedRow;
      let newCollpaseList = state.collapseRowList?.filter(
        (x) => x[0] != expandedRow[0]
      );
      return { ...state, collapseRowList: newCollpaseList };
    case SET_COLLAPSE_ROW_LIST:
      return {
        ...state,
        collapseRowList: action.data.collapseRowList,
      };
    case SET_CURRENT_SELECTED_ROW:
      return {
        ...state,
        currentSelectedRow: action.data.currentSelectedRow,
        currentDeselectedRow: action.data.currentDeselectedRow,
      };
      case SET_SUMMARY_LIST_HEIGHT:
      return {
        ...state,
        summaryGridHeight: action.data.summaryGridHeight
      };
    default:
      return state;
  }
}
